import { PipeTransform, Pipe } from '@angular/core';

import { IMemberProviderNetworkEntry } from '@sondermind/data-access/provider-facing/provider-profile';

@Pipe({
  name: 'sortProviderNetworkList',
  standalone: false
})
export class SortProviderNetworkListPipe implements PipeTransform {
  transform(items: IMemberProviderNetworkEntry[]): IMemberProviderNetworkEntry[] {
    if (!items?.length) return [];

    return items.sort((a, b) => {
      const aHasSelfPay = a.name.includes('Self-pay');
      const bHasSelfPay = b.name.includes('Self-pay');

      // if one has "Self-Pay", give it priority
      if (aHasSelfPay && !bHasSelfPay) return -1;
      if (!aHasSelfPay && bHasSelfPay) return 1;

      // Otherwise, sort alphabetically by name
      return a.name.localeCompare(b.name);
    });
  }
}
